var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "contract-list" },
    [
      _c(
        "ob1-popin-modal2",
        {
          attrs: {
            id: _vm.id,
            "aria-labelledby": _vm.ariaLabelId,
            "show-close-button": false,
          },
        },
        [
          _c(
            "div",
            { ref: "contractListPageRef", staticClass: "contract-list-page" },
            [
              _c("div", { staticClass: "container-fluid list-contracts" }, [
                _c("div", { staticClass: "row pb-1" }, [
                  _c("div", { staticClass: "col-12 pt-2" }, [
                    _c("h2", {
                      staticClass: "mb-0",
                      domProps: { innerHTML: _vm._s(_vm.routeCustomerTitle) },
                    }),
                    _vm._v(" "),
                    _c("h3", {
                      staticClass: "pt-3 mb-0",
                      domProps: {
                        innerHTML: _vm._s(_vm.contractsPageData.label),
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "items-list row" },
                  _vm._l(_vm.contracts, function (contract, index) {
                    return _c(
                      "div",
                      { key: contract.id, staticClass: "col-12" },
                      [
                        !contract.enabled
                          ? _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "items-list-item disabled d-block",
                                  },
                                  [
                                    _c("contract-item", {
                                      attrs: { contract: contract },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "col-12 ps-4 pt-1 pb-2 text-gray3 small",
                                  staticStyle: { "max-width": "28.125rem" },
                                },
                                [
                                  _vm._v(
                                    "\n                                Cette offre n'est pas compatible\n                            "
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        contract.enabled
                          ? _c("div", [
                              contract.rerouting == null
                                ? _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-12 pb-2" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "items-list-item d-block",
                                          class: [
                                            contract.selected &&
                                            contract.enabled
                                              ? "highlight"
                                              : "",
                                            contract.enabled
                                              ? "changeContract"
                                              : "disabled",
                                          ],
                                          attrs: {
                                            "aria-disabled": !contract.enabled,
                                            href: "javascript:void(0)",
                                            "data-oevent-category":
                                              _vm.contractsPageData
                                                .contractListTagZone,
                                            "data-oevent-action":
                                              contract.offerLabel,
                                            "data-oevent-label": index + 1,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.getContractUrl(
                                                contract
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("contract-item", {
                                            attrs: { contract: contract },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              contract.rerouting != null
                                ? _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "items-list-item d-block",
                                          class: [
                                            contract.selected &&
                                            contract.enabled
                                              ? "highlight"
                                              : "",
                                            contract.enabled
                                              ? "changeContractRerouting"
                                              : "",
                                          ],
                                          attrs: {
                                            "aria-disabled": !contract.enabled,
                                            href: "javascript:void(0)",
                                            "data-oevent-category":
                                              _vm.contractsPageData
                                                .contractListTagZone,
                                            "data-oevent-action":
                                              contract.offerLabel,
                                            "data-oevent-label": index + 1,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.getContractUrl(
                                                contract
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("contract-item", {
                                            attrs: { contract: contract },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass:
                                        "col-12 ps-4 pt-1 pb-2 text-gray3 small",
                                      staticStyle: { "max-width": "28.125rem" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          contract.rerouting.messageDescription
                                        ),
                                      },
                                    }),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 pt-1 pb-2" }, [
                    _c("h4", {
                      staticClass: "h3 mb-0",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.contractsPageData.contractNotFoundTitle
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "lead fw-bold pt-1",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.contractsPageData.contractNotFoundLabel
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "py-1" }, [
                      _c("a", {
                        staticClass: "btn btn-primary mx-auto",
                        attrs: {
                          "data-oevent-category":
                            _vm.contractsPageData.identifyButtonTms.zone,
                          "data-oevent-action":
                            _vm.contractsPageData.identifyButtonTms.name,
                          "data-oevent-label":
                            _vm.contractsPageData.identifyButtonTms.target,
                          href: _vm.authenticationUrl,
                        },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.contractsPageData.contractNotFoundButton
                          ),
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }